export enum PreviewStatus {
  full = 'full',
  partial = 'partial',
  noview = 'noview',
}

export interface GoogleBook {
  bib_key: string;
  can_download_epub: boolean;
  can_download_pdf: boolean;
  embeddable: boolean;
  info_url: string;
  is_epub_drm_enabled: boolean;
  is_pdf_drm_enabled: boolean;
  preview: PreviewStatus;
  preview_url: string;
  thumbnail_url: string;
}

export type GoogleBooksResponse = {
  [bibKey: string]: GoogleBook;
};
